import {
    GET_ONCALLS_SUCCESS,
    GET_ONCALLS_FAIL,
    GET_ONCALLS,
    POST_ONCALLS,
    POST_ONCALLS_FAIL,
} from "./actionTypes";

// oncalls data

export const getOncalls = () => ({
  type: GET_ONCALLS,
})

export const getOncallsSuccess = oncalls => ({
  type: GET_ONCALLS_SUCCESS,
  payload: oncalls,
})

export const getOncallsFail = error => ({
  type: GET_ONCALLS_FAIL,
  payload: error,
})

export const postOncalls = (oncalls) => {
  return {
    type: POST_ONCALLS,
    payload: { oncalls }
  }
}

export const postOncallsFail = error => ({
  type: POST_ONCALLS_FAIL,
  payload: error,
})